import type { ComponentType } from 'react';
import PasswordCrackerView from './PasswordCrackerView';
import PortScanSweepView from './PortScanSweepView';
import PacketRoutingView from './PacketRoutingView';
import CipherBreakerView from './CipherBreakerView';
import LogScrubberView from './LogScrubberView';
import LoadBalancerView from './LoadBalancerView';
import PayloadBuilderView from './PayloadBuilderView';
import VirusSpreadView from './VirusSpreadView';
import TriangulationView from './TriangulationView';
import RootkitAssemblyView from './RootkitAssemblyView';
import RaceConditionView from './RaceConditionView';
import SandboxEscapeView from './SandboxEscapeView';
import BotnetCommandView from './BotnetCommandView';
import LedgerForgeView from './LedgerForgeView';
import ZeroDayFuzzingView from './ZeroDayFuzzingView';
import ScadaOverrideView from './ScadaOverrideView';
import CounterIntrusionView from './CounterIntrusionView';
import QuantumKeyView from './QuantumKeyView';
import ModelPoisoningView from './ModelPoisoningView';
import DeepCoreView from './DeepCoreView';
import type { MinigameViewProps } from '../../types/minigame';

// Maps a minigame id to the component that renders it. The host page (pages/Minigames.tsx)
// owns everything generic — start/submit, the countdown, the result screen, rewards — so a
// new minigame only has to render its puzzle and call onSubmit.
//
// Ids must match MinigameIds in HackingGame.Shared. A game whose engine exists server-side
// but has no entry here simply can't be launched from the UI, so add both together.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MINIGAME_VIEWS: Record<string, ComponentType<MinigameViewProps<any, any>>> = {
  // Registered as each minigame UI is written.
  'password-cracker': PasswordCrackerView,
  'port-scan-sweep': PortScanSweepView,
  'packet-routing': PacketRoutingView,
  'cipher-breaker': CipherBreakerView,
  'log-scrubber': LogScrubberView,
  'load-balancer': LoadBalancerView,
  'payload-builder': PayloadBuilderView,
  'virus-spread': VirusSpreadView,
  'triangulation': TriangulationView,
  'rootkit-assembly': RootkitAssemblyView,
  'race-condition': RaceConditionView,
  'sandbox-escape': SandboxEscapeView,
  'botnet-command': BotnetCommandView,
  'ledger-forge': LedgerForgeView,
  'zero-day-fuzzing': ZeroDayFuzzingView,
  'scada-override': ScadaOverrideView,
  'counter-intrusion': CounterIntrusionView,
  'quantum-key': QuantumKeyView,
  'model-poisoning': ModelPoisoningView,
  'deep-core': DeepCoreView,
};

export function findMinigameView(id: string) {
  return MINIGAME_VIEWS[id];
}
